import {db} from "../../firebase";
import firebase from "firebase/compat/app";
import {Collections} from "../collections";

export const updateCompanyRmWaiting = (rmId: string, email: string) => {
    if (!email || !rmId) return Promise.reject("bad params");

    return db.collection(Collections.COMPANY_RM_WAITING).doc(rmId).set({
        rmId,
        emails: firebase.firestore.FieldValue.arrayUnion(email)
    }, {merge: true});
}